import reactI18n from '@volcengine/i18n'
import { getVText } from 'servers/getVText';

// 定义 ModuleType 类型
enum ModuleType {
  BACKEND = 'backend',
}

// 定义 Module 接口
interface Module {
  type: ModuleType;
  init: (services: any, backendOptions: any, i18nOptions: any) => void;
  read: (language: string, translations: any, callback: (error: any, resources: any) => void) => Promise<void>;
}

const namespaces: { [k: string]: number[] } = {
  '/hb3storage/guide': [42526],
  '/hb3storage/expanding': [42526],
  '/hb3storage/installation': [42526],
  '/hb3storage/formating': [42526],
  '/hb3storage/backup': [42526],
  '/recommend/solution': [44612],
}

const customBackend: Module = {
  type: ModuleType.BACKEND,
  init: (services, backendOptions, i18nOptions) => {
    // 初始化相应处理
  },
  read: async (language: string, translations, callback: (arg0: null, arg1: null) => void) => {
    // const { backend } = getOptions()
    // if (!backend?.namespace || backend.namespace.length === 0) {
    //   callback(null, null)
    //   return
    // }
    try {
      // const data = await getVText(language, String(backend.projectId), backend?.namespace?.toString())
      // 替换为 mega 文案管理
      const data = await getVText(language, "6191", "44629","rec_,h5_")
      if(data && Object.keys(data).length > 0) {
         callback(null, data)
      }else{
        callback(null, null)
      }
    }catch(e) {
      console.error(e)
      callback(null, null)
    }
  },
}

function getOptions() {
  const pathname = window.location.pathname
  const baseNamespace = pathname.split('/').filter(Boolean).slice(0, 2).join('/')
  const namespace = namespaces[`/${baseNamespace}`] || []
  const options = {
    backend: {
      namespace, // 空间名
      operatorId: 2100049119,
      apiKey: '535c80500e5a11edabb1dba2faf88c8b',
      projectId: 4829,
      timeout: 30000, // 接口请求超时时间，默认10s
      host: 'https://starling-public.byteintlapi.com', // 使用海外节点时，需要配置此项
    },
    fallbackLng: ['en'],
    react: {
      useSuspense: false, // 默认为true，false关闭Suspense
    },
  }
  return options
}

function init() {
  const initOptions = getOptions()
  reactI18n
    .use(customBackend) // 使用自定义后端
    .init(initOptions)
}

init()

// export default reactI18n
